import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint, LoadableLazy } from '@confluence/loadable';
import { FavouriteButtonPlaceholder } from './FavouriteButtonPlaceholder.ts';

export const FavouriteButton: LoadableType<{
	contentId: string;
	isDisabled?: boolean;
}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-FavouriteButton" */ '../src/FavouriteButton.tsx'))
			.FavouriteButton,
	loading: FavouriteButtonPlaceholder,
});
export const LazyFavouriteButton: LoadableType<{
	contentId: string;
	isDisabled?: boolean;
}> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-FavouriteButton" */ '../src/FavouriteButton.tsx'))
			.FavouriteButton,
	loading: FavouriteButtonPlaceholder,
});
